import React from 'react';
import { useParams } from 'react-router';
import { useQuery, useMutation } from '@apollo/client';
import { message, Spin, Typography } from 'antd';
import fp from 'lodash/fp';
import ReportSettingsForm from './ReportSettingsForm';
import objMap from '../../../utils/objMap';
import {
  GET_REPRORT_SETTINGS,
  UPDATE_REPRORT_SETTINGS,
} from '../../../gql/projectCategories';

const getInitialValues = (data) => {
  return fp.pipe(
    fp.get('projectCategories'),
    fp.head,
    fp.get('reportSettings'),
    fp.reduce((acc, { reportType, reportForm }) => {
      acc[reportType] = reportForm;
      return acc;
    }, {})
  )(data);
};

const formatInput = objMap((reportType, reportForm) => ({
  reportType,
  reportForm,
}));

const { Text } = Typography;

const TabReportSettings = () => {
  const { id } = useParams();
  const { data, loading } = useQuery(GET_REPRORT_SETTINGS, {
    variables: { ids: [id], state: 'ALL' },
  });
  const [updateReportSettings, { loading: mutationLoading }] = useMutation(
    UPDATE_REPRORT_SETTINGS,
    {
      refetchQueries: [
        { query: GET_REPRORT_SETTINGS, variables: { ids: [id], state: 'ALL' } },
      ],
      onCompleted: ({ updateReportSettings }) => {
        message.success(
          `Report settings of ${updateReportSettings.name} successfully edited`
        );
      },
      onError: (err) => {
        console.log(err);
      },
    }
  );
  return (
    <Spin spinning={mutationLoading} tip="Updating...">
      <Text
        type="secondary"
        style={{ display: 'block', paddingBottom: '16px' }}
      >
        Report Settings for report submission
      </Text>
      {!loading && (
        <ReportSettingsForm
          key={id}
          onFinish={(input) => {
            updateReportSettings({
              variables: {
                updateReportSettingsInput: {
                  id,
                  reportSettings: formatInput(input),
                },
              },
            });
          }}
          initialValues={getInitialValues(data)}
        />
      )}
    </Spin>
  );
};

export default TabReportSettings;
